// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BtnFavori_wrapper__6QfUB","checked":"BtnFavori_checked__2c-_t","picto":"BtnFavori_picto__256tY","animation":"BtnFavori_animation__1qJeq","pop":"BtnFavori_pop__3LyfD"};